import { connect } from 'react-redux'
import Contributors from './contributors'
import {
  getFetchRequest,
  getContributorsList,
  getAssessmentFileId,
  getAssessmentFileClosedState,
  getAssessmentFile
} from '../../../../../../stores/assessment-file/assessment-file.selectors'
import {
  openInvitationAssessmentDialog,
  openInviteesDialog
} from '../../../../../../stores/assessment-file/assessment-file.actions'

const mapStateToProps = (state, { me }) => {
  const assessmentFile = getAssessmentFile(state)
  return {
    id: getAssessmentFileId(state),
    pending: getFetchRequest(state).pending,
    contributors: getContributorsList(state) || [],
    closed: getAssessmentFileClosedState(state),
    canSeeInvitees: assessmentFile.policy.can_view_guest_moderators,
    inviteesCount: assessmentFile.guest_moderator_count
  }
}

const mapDispatchToProps = dispatch => ({
  onOpenInvitationAssessmentDialog: id =>
    dispatch(openInvitationAssessmentDialog(id)),
  onOpenInviteesDialog: id => dispatch(openInviteesDialog(id))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contributors)
